document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.querySelector('#product-grid');
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    if (!productGrid || !paginationWrapper) return;

    let isLoading = false;
    let infiniteStarted = false;
    let observer = null;
    let sentinel = null;

    // Dawn uses pagination__item--prev for the "next" arrow button
    const nextPageLink = paginationWrapper.querySelector('.pagination__item--prev');
    if (!nextPageLink) return; // no more pages, do nothing

    // Hide original pagination always
    paginationWrapper.style.display = 'none';

    // Loading indicator
    const loadingIndicator = document.createElement('div');
    const loadingText = window.theme?.strings?.loading_more || 'Cargando más productos...';
    loadingIndicator.className = 'infinite-scroll-loading hidden';
    loadingIndicator.innerHTML = `<div class="loading-spinner">${loadingText}</div>`;
    productGrid.after(loadingIndicator);

    // Manual CTA (first load)
    const showMoreText = window.theme?.strings?.show_more || 'Ver más productos';
    const ctaWrap = document.createElement('div');
    ctaWrap.className = 'manual-load-more-wrap flex justify-center ';

// your CTA button
    const cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'manual-load-more button button--primary';
    cta.textContent = showMoreText;

// insert wrapper before loading indicator, then put the button inside
    loadingIndicator.before(ctaWrap);
    ctaWrap.appendChild(cta);


    // We’ll create the sentinel only after the first manual load
    function startInfinite() {
        if (infiniteStarted) return;
        infiniteStarted = true;

        sentinel = document.createElement('div');
        sentinel.className = 'infinite-scroll-sentinel';
        sentinel.innerHTML = '&nbsp;';
        loadingIndicator.after(sentinel);

        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !isLoading) {
                    loadMoreProducts();
                }
            });
        }, { rootMargin: '200px', threshold: 0 });

        observer.observe(sentinel);
    }

    async function loadMoreProducts() {
        const nextLink = paginationWrapper.querySelector('.pagination__item--prev');
        if (!nextLink || isLoading) return;

        isLoading = true;
        loadingIndicator.classList.remove('hidden');

        try {
            const url = nextLink.href;
            const response = await fetch(url);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // New products
            const newProducts = doc.querySelectorAll('#product-grid > li');
            if (newProducts.length) {
                newProducts.forEach((li) => productGrid.appendChild(li));

                // Update pagination markup
                const newPaginationWrapper = doc.querySelector('.pagination-wrapper');
                if (newPaginationWrapper) {
                    paginationWrapper.innerHTML = newPaginationWrapper.innerHTML;

                    // If no more next page, clean up infinite scroll
                    const hasNextPage = paginationWrapper.querySelector('.pagination__item--prev');
                    if (!hasNextPage) {
                        if (observer) observer.disconnect();
                        if (sentinel) sentinel.remove();
                        loadingIndicator.remove();
                    }
                } else {
                    // Safety: no pagination found in new doc
                    if (observer) observer.disconnect();
                    if (sentinel) sentinel.remove();
                    loadingIndicator.remove();
                }

                // Update URL to the page we just loaded
                //window.history.replaceState({}, '', url);
            }
        } catch (err) {
            // optional: console.error(err);
        } finally {
            isLoading = false;
            loadingIndicator.classList.add('hidden');
        }
    }

    // First manual click: load once, then start infinite
    cta.addEventListener('click', async () => {
        if (isLoading) return;
        cta.disabled = true;
        cta.classList.add('is-loading');
        cta.textContent = loadingText;
        ctaWrap.remove();
        await loadMoreProducts();

        // Remove CTA and kick off infinite scrolling
        startInfinite();
    });
});
